export const WARNING_SLICE = 'WARNING_SLICE';
